import React, { Fragment } from 'react';
import { getEditorPreloader } from '@confluence-classic/confluence-fabric-editor/src/editorPreloader';
import { CommentsSectionLoader } from '@confluence-classic/confluence-utils/entry-points/CommentsSectionLoader';
import { ClassicEditorContextProviderLoader } from '@confluence-classic/confluence-fabric-editor/src/components/ClassicEditorContextProvider';

import { EditContentButtonPreloaderContext } from '@confluence/edit-button/entry-points/EditContentButtonPreloaderContext';
import { EmbeddedViewPageLoader } from '@confluence/embedded-confluence/entry-points/EmbeddedViewPage';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary';
import { ViewPageLoader } from '@confluence/view-page/entry-points/ViewPage';
import { PageShownPublicLinksEventLoader } from '@confluence/external-share-utils/entry-points/PageShownPublicLinksEventLoader';
import { PresenterModeContextProvider } from '@confluence/presentation-mode';

import SendTrackViewPageEvent from '../../SendTrackViewPageEvent';
import { ContentExtensionsProvider } from '../../ContentExtensionsProvider';
import SpaceBase from '../../SpaceBase';
import {
	LazyDwellTime,
	LazyMobileWebContainer,
	LazyConsumptionViewedAndCompletedEventTracker,
} from '../lazyComponents';
import { CommentContextWrapper } from '../commentContextWrapper';
/**
 * This component handles page, blog and space overview routes
 */
export const ViewPageRouteComponent = ({
	spaceKey,
	contentId,
	isPage,
	isMobile,
	isEmbeddedConfluence,
}) => {
	const pageType = isPage ? 'page' : 'blogpost';

	let component;
	if (isEmbeddedConfluence) {
		component = (
			<CommentContextWrapper>
				<EmbeddedViewPageLoader
					contentId={contentId}
					spaceKey={spaceKey}
					classicComments={CommentsSectionLoader}
					ClassicEditorContextProviderLoader={ClassicEditorContextProviderLoader}
				/>
			</CommentContextWrapper>
		);
	} else if (isMobile) {
		component = (
			<CommentContextWrapper>
				<LazyMobileWebContainer />
			</CommentContextWrapper>
		);
	} else {
		component = (
			<CommentContextWrapper>
				<EditContentButtonPreloaderContext.Provider value={getEditorPreloader()}>
					<PresenterModeContextProvider contentId={contentId} spaceKey={spaceKey}>
						<ViewPageLoader
							spaceKey={spaceKey}
							contentId={contentId}
							classicComments={CommentsSectionLoader}
							ClassicEditorContextProviderLoader={ClassicEditorContextProviderLoader}
						>
							<ErrorBoundary attribution={Attribution.BACKBONE}>
								<SendTrackViewPageEvent pageType={pageType} />
							</ErrorBoundary>
						</ViewPageLoader>
					</PresenterModeContextProvider>
				</EditContentButtonPreloaderContext.Provider>
			</CommentContextWrapper>
		);
	}

	return (
		<Fragment>
			<SpaceBase>
				<ContentExtensionsProvider>{component}</ContentExtensionsProvider>
			</SpaceBase>
			<LazyDwellTime />
			<LazyConsumptionViewedAndCompletedEventTracker
				spaceKey={spaceKey}
				source="ViewPageRouteComponent"
				skip={isMobile}
			/>
			<PageShownPublicLinksEventLoader contentId={contentId} isPage={isPage} />
		</Fragment>
	);
};
